import { useQuery } from '@tanstack/react-query';
import type { GetPackageRequestTypes } from '..';
import { getPackage } from '..';
import { queryKey } from './query-key';

export type UseGetPackageParams = Partial<GetPackageRequestTypes>;

/**
 * Custom hook to fetch package using React Query.
 *
 * @param params - Parameters for fetching packages.
 */
export const useGetPackage = (params: UseGetPackageParams) =>
  useQuery({
    queryKey: queryKey.package(params.packageId!),
    queryFn: () =>
      getPackage({
        packageId: params.packageId!,
      }),
    enabled: Boolean(params.packageId),
  });
